export const conversion = (
    count: number,
    trls: {
        zero: string;
        one: string;
        some: string;
        many: string;
    }
): string => {
    const absCount = Math.abs(count);
    const mod100 = absCount % 100;
    const mod10 = absCount % 10;

    if (count === 0) return trls.zero;
    if (mod100 >= 5 && mod100 <= 20) return trls.many;
    if (mod10 === 1) return trls.one;
    if (mod10 >= 2 && mod10 <= 4) return trls.some;
    return trls.many;
};
